import { render } from "./approvalList.vue?vue&type=template&id=746c22b0"
import script from "./approvalList.vue?vue&type=script&lang=js"
export * from "./approvalList.vue?vue&type=script&lang=js"

import "./approvalList.vue?vue&type=style&index=0&id=746c22b0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__